module.exports = __webpack_public_path__ + "17cdb9f1e548443942ccff2f75514fcd.png";